import React from "react";
import { Row, Col } from "reactstrap";
import { MenuItem, Icon, Menu } from "semantic-ui-react";
import { PDF_URL } from "../constants";

export const PDFPreview = (props) => {
  return (
    <div style={{ height: "80vh" }}>
      <iframe
        style={{ height: "80%", width: "100%", border: "none" }}
        src={`${PDF_URL + props.doc.id}`}
      />
    </div>
  );
};

export const PDFPreviewList = (props) => {
  let { data } = props;
  // data = data || pdfList.slice(0, 4);
  const [doc, setDoc] = React.useState(data?.[0]);
  if (data.length === 0) {
    return (
      <center style={{ margin: "60px", color: "gray", fontStyle: "italic" }}>
        <h3>Tidak ada Dokumen</h3>
      </center>
    );
  }
  if (data.length === 1) {
    return <PDFPreview doc={data[0]} />;
  }
  return (
    <Row>
      <Col md="4" style={{ height: "60vh", overflowY: "auto" }}>
        <Menu className="w-100" vertical secondary inverted>
          {data.map((d, i) => (
            <Menu.Item
              key={i}
              color="blue"
              name={d.id}
              active={d.id === doc.id}
              onClick={(e) => setDoc(d)}
            >
              {d.name || d.id}
            </Menu.Item>
          ))}
        </Menu>
      </Col>
      <Col style={{ height: "80vh" }}>
        <iframe
          style={{ height: "80%", width: "100%", border: "none" }}
          src={`${PDF_URL + doc.id}`}
        />
      </Col>
    </Row>
  );
};
const pdfList = [
  {
    id: "fe1164b5-55cb-4fcb-8fc7-54117e265803.pdf",
    name: "PT BIJB tahun 2020.pdf",
  },
];
